import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import EditIcon from '@material-ui/icons/Edit';
import GroupIcon from '@material-ui/icons/Group';
import Avatar from '@ublend-npm/aulaui-next-web/Avatar';
import ListItem from '@ublend-npm/aulaui-next-web/ListItem';

import ViewGroupParticipantsDialog from './ViewGroupParticipantsDialog';
import { EditGroupDialog } from './CreateEditGroupDialog';

import { ListItemText, ListItemIcon } from './ListItem.styled';

const GroupListItem = ({
  groupId,
  name,
  avatar,
  numMembers,
  isInstructor,
  onEditGroup,
}) => {
  const [viewParticipantsDialogOpen, setViewParticipantsDialogOpen] = useState(
    false
  );
  const handleViewParticipantsClick = useCallback(
    () => setViewParticipantsDialogOpen(true),
    [viewParticipantsDialogOpen]
  );
  const handleViewParticipantsDialogClose = useCallback(
    () => setViewParticipantsDialogOpen(false),
    [viewParticipantsDialogOpen]
  );

  const [iconVisible, setIconVisible] = useState(false);
  const showIcon = () => setIconVisible(true);
  const hideIcon = () => setIconVisible(false);

  const icon = iconVisible ? (
    <ListItemIcon IconType={isInstructor ? EditIcon : GroupIcon} />
  ) : null;

  const handleGroupListItemClick = isInstructor
    ? onEditGroup
    : handleViewParticipantsClick;

  const membersText =
    numMembers !== 1 ? `${numMembers} participants` : '1 participant';

  return (
    <div onMouseEnter={showIcon} onMouseLeave={hideIcon} onBlur={hideIcon}>
      <ListItem
        className="group-item"
        size="large"
        onClick={handleGroupListItemClick}
        leftDecoration={
          <React.Fragment>
            <ListItemAvatar>
              <Avatar size="large" name={name} src={avatar} />
            </ListItemAvatar>
            <ListItemText primary={name} secondary={membersText} />
          </React.Fragment>
        }
        rightDecoration={icon}
      />
      <ViewGroupParticipantsDialog
        open={viewParticipantsDialogOpen}
        onClose={handleViewParticipantsDialogClose}
        groupId={groupId}
      />
    </div>
  );
};

GroupListItem.propTypes = {
  groupId: PropTypes.string.isRequired,
  name: PropTypes.string,
  avatar: PropTypes.string,
  numMembers: PropTypes.number,
  isInstructor: PropTypes.bool,
  onEditGroup: PropTypes.func.isRequired,
};

GroupListItem.defaultProps = {
  name: '',
  avatar: null,
  numMembers: 0,
  isInstructor: false,
};

export default GroupListItem;
